import type { MaybeRef } from "@vueuse/core"

interface UsePaginationOptions {
  count: MaybeRef<number>
  limit: MaybeRef<number>
}

export const usePagination = ({
  count,
  limit = 10,
}: UsePaginationOptions) => {
  const defaultPagination = computed(() => ({
    limit: unref(limit),
    offset: 0,
  }))
  const pagination = ref<Pagination>({
    ...defaultPagination.value,
  })

  const resetPagination = () => {
    pagination.value = { ...defaultPagination.value }
  }

  const page = computed({
    get: () =>
      Math.floor(
        pagination.value.offset / pagination.value.limit
      ) + 1,
    set: (value) => {
      pagination.value.offset =
        pagination.value.limit * (value - 1)
    },
  })

  const pageCount = computed(() =>
    Math.ceil(unref(count) / pagination.value.limit)
  )

  return {
    page,
    pageCount: readonly(pageCount),
    pagination: readonly(pagination),
    resetPagination,
  }
}
